import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

import { getPrivateMessageList } from '../../../api/messenger';

import { findOpenedConversations } from '../../../components/Messenger/utils/findNewConversations';
import { normalizeChats } from '../../../components/Messenger/utils/normolizeChats';

import { REQUEST } from '../../../constants/request';

export const fetchPrivateMessageList = createAsyncThunk(
  'messenger/fetchPrivateMessageList',
  async (args, { signal, rejectWithValue }) => {
    const source = axios.CancelToken.source();
    signal.addEventListener('abort', () => {
      source.cancel();
    });

    try {
      const response = await getPrivateMessageList(args, {
        cancelToken: source.token,
      });

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.status);
    }
  },
  {
    condition: (arg, { getState }) => {
      const currentLoading =
        getState().messenger.currentLoadings?.messageList || REQUEST.idle;

      return currentLoading !== REQUEST.pending;
    },
  },
);

export const fetchPrivateMessageListExtraReducers = builder => {
  builder
    .addCase(fetchPrivateMessageList.pending, (state, { meta }) => {
      state.currentLoadings.messageList = REQUEST.pending;
      state.currentRequestIds.messageList = meta.requestId;
    })
    .addCase(fetchPrivateMessageList.fulfilled, (state, { payload }) => {
      const { byId, allIds, conversations } = normalizeChats(state, payload);
      const openedConversations = findOpenedConversations(state, payload);
      state.conversations = {
        ...state.conversations,
        [state.selectedChannelUID]: [...openedConversations, ...conversations],
      };
      state.chats.byId = byId;
      state.chats.allIds = allIds;
      state.currentLoadings.messageList = REQUEST.idle;
      state.currentRequestIds.messageList = undefined;
    })
    .addCase(fetchPrivateMessageList.rejected, (state, { payload }) => {
      state.currentLoadings.messageList = REQUEST.idle;
      state.currentRequestIds.messageList = undefined;
      state.currentErrors.messageList = payload;
    });
};
